import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var ModBusDevice;
(function (ModBusDevice) {
    ModBusDevice.get = createAccessors(arrayGetSet('modbus_devices'), {
        address: 1,
        name: 'Устройство Modbus',
        period: 1000,
        time_for_disconnect: 300000,
        rol_connection_lost: [],
        rol_reconnection: [],
        setting_register: 0,
        signals: [],
    });
})(ModBusDevice || (ModBusDevice = {}));
